"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatbotView = void 0;
const react_1 = __importStar(require("react"));
const models_1 = require("./models");
const logic_1 = require("./services/logic");
const ChatBlock_1 = require("./ChatBlock");
const store_1 = require("./store");
const chatbot_1 = require("./services/chatbot");
const uuid_1 = require("uuid");
const react_i18next_1 = require("react-i18next");
const Scroll = __importStar(require("react-scroll"));
const LoadingBlock_1 = require("./ChatBlock/LoadingBlock");
const theme_1 = require("./services/theme");
const utils_1 = require("./services/utils");
const scroll = Scroll.animateScroll;
const ChatbotView = ({ chatbot, isPreview, disableAnimations, onChatbotAnswer, onChatbotCompleted, }) => {
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    const chatbotFromStore = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const stepsFromStore = (0, store_1.useStoreState)((state) => state.stepsDisplayed.value);
    const chatbotAnswers = (0, store_1.useStoreState)((state) => state.chatbotAnswers.value);
    const { setStepsDisplayed: setStepsInStore, addStep } = (0, store_1.useStoreActions)((actions) => actions.stepsDisplayed);
    const { setChatbot: setChatbotInStore, setComputationVariableValue, setQuestionVariableValue, setHttpVariableValue, } = (0, store_1.useStoreActions)((action) => action.chatbot);
    const { setAnswers: setAnswersInStore, removeLastAnswer, addAnswer, } = (0, store_1.useStoreActions)((action) => action.chatbotAnswers);
    const [stepsDisplayed, setStepsDisplayed] = (0, react_1.useState)([]);
    const [previousTriggered, setPreviousTriggered] = (0, react_1.useState)(false);
    const [isEnded, setIsEnded] = (0, react_1.useState)(false);
    const [isContinuingWithPreviousAnswers, setIsContinuingWithPreviousAnswers] = (0, react_1.useState)(false);
    const [isExecutingHttpRequest, setIsExecutingHttpRequest] = (0, react_1.useState)(false);
    const bottomAnchor = (0, react_1.useRef)(null);
    const showCreateYourOwnButton = chatbot.settings
        ? chatbot.settings.showCreateYourOwnButton
        : true;
    (0, react_1.useEffect)(() => {
        try {
            flushHttpLocalStorage();
        }
        catch (e) { }
        i18n.changeLanguage(chatbot.language);
        if (!chatbot.steps[0])
            return;
        initFirstStep();
    }, []);
    (0, react_1.useEffect)(() => {
        const clickedOnBack = stepsFromStore.length < stepsDisplayed.length;
        if (!clickedOnBack)
            return;
        rollbackToLastStep();
    }, [stepsFromStore]);
    const initFirstStep = () => {
        var _a, _b, _c, _d;
        const userIsRemembered = !isPreview &&
            ((_b = (_a = chatbot.settings.refreshFirstStep) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : false) &&
            chatbotFromStore &&
            chatbotFromStore.modifiedDate === chatbot.modifiedDate &&
            chatbotAnswers.length > 0;
        if (userIsRemembered) {
            let secondVisitStep;
            if ((_d = (_c = chatbot.settings) === null || _c === void 0 ? void 0 : _c.refreshFirstStep) === null || _d === void 0 ? void 0 : _d.value) {
                secondVisitStep = Object.assign(Object.assign({}, chatbot.settings.refreshFirstStep.value), { chatbotStepIndex: -1 });
            }
            else {
                secondVisitStep = (0, chatbot_1.getKnowYouStep)(t);
            }
            addStep(secondVisitStep);
            setStepsDisplayed([secondVisitStep]);
            return;
        }
        setChatbotInStore(chatbot);
        setAnswersInStore([]);
        setStepsInStore([]);
        displayNextBlock({ stepsDisplayed: [], upToDateAnswers: [] });
    };
    const rollbackToLastStep = () => {
        setIsEnded(false);
        const steps = [...stepsDisplayed];
        steps.splice(stepsFromStore.length, stepsDisplayed.length - stepsFromStore.length);
        const lastStep = steps[steps.length - 1];
        steps[steps.length - 1] = Object.assign(Object.assign({}, lastStep), { showReplyAvatar: true });
        setStepsDisplayed(steps);
        setPreviousTriggered(true);
        setTimeout(() => {
            setPreviousTriggered(false);
        }, 1000);
    };
    const displayNextBlock = ({ upToDateAnswers, stepsDisplayed, skip, freshQuestionVariables, }) => __awaiter(void 0, void 0, void 0, function* () {
        const lastStepDisplayed = [...stepsDisplayed].pop();
        const currentChatbot = updateChatbot(Object.assign({}, (chatbotFromStore !== null && chatbotFromStore !== void 0 ? chatbotFromStore : chatbot)), freshQuestionVariables);
        const brain = new logic_1.ChatbotBrain({
            chatbot: currentChatbot,
            answers: upToDateAnswers,
            actions: {
                setComputationVariableValue,
                setHttpVariableValue,
                setQuestionVariableValue,
                setIsExecutingHttpRequest,
                onChatbotAnswer,
            },
        });
        const { nextIndex, validatedConditionId } = yield brain.computeNextIndex(lastStepDisplayed, currentChatbot.startConditions);
        if (nextIndex === (lastStepDisplayed === null || lastStepDisplayed === void 0 ? void 0 : lastStepDisplayed.chatbotStepIndex) &&
            lastStepDisplayed.answerType === models_1.InputType.NO_INPUT) {
            if (typeof localStorage !== "undefined" &&
                (0, utils_1.getItemFromLocalStorage)("blockRequest")) {
                setIsEnded(true);
                return;
            }
            displayNextBlock({
                upToDateAnswers,
                stepsDisplayed,
                skip,
                freshQuestionVariables,
            });
            return;
        }
        const lastAnswer = upToDateAnswers[upToDateAnswers.length - 1];
        const isFormBeingConsumed = !skip && lastAnswer && lastAnswer.questionId;
        if (isFormBeingConsumed) {
            lastAnswer.conditionId = validatedConditionId;
            addAnswer(lastAnswer);
            onChatbotAnswer(upToDateAnswers).then();
        }
        setNextBlock(stepsDisplayed, nextIndex);
    });
    const updateChatbot = (chatbot, updatedQuestionVariables) => {
        if (updatedQuestionVariables) {
            chatbot.variables.questionVariables = [...updatedQuestionVariables];
        }
        return chatbot;
    };
    const setNextBlock = (stepsDisplayed, nextIndex) => {
        const lastStepDisplayed = [...stepsDisplayed].pop();
        stepsDisplayed[stepsDisplayed.length - 1] = Object.assign(Object.assign({}, lastStepDisplayed), { showReplyAvatar: false });
        let nextStep = Object.assign(Object.assign({}, chatbot.steps[nextIndex]), { chatbotStepIndex: nextIndex, showReplyAvatar: true });
        const noStepToDisplay = !nextStep.id;
        if (noStepToDisplay) {
            if (onChatbotCompleted) {
                onChatbotCompleted();
            }
            setIsEnded(true);
            if (!showCreateYourOwnButton) {
                return;
            }
            nextStep = (0, chatbot_1.shareStep)(chatbot, t);
        }
        addStep(nextStep);
        setStepsDisplayed([...stepsDisplayed, nextStep]);
    };
    const displayRetryQuestion = () => {
        var _a, _b, _c, _d, _e, _f;
        const lastStepDisplayed = [...stepsDisplayed].pop();
        if (!lastStepDisplayed)
            throw Error("lastStepDisplayed undefined");
        const retryStep = Object.assign(Object.assign({}, lastStepDisplayed), { id: (0, uuid_1.v4)() });
        let retryMessage = t("Im not sure to understand");
        switch (lastStepDisplayed.answerType) {
            case models_1.InputType.EMAIL: {
                if ((_b = (_a = chatbot.settings) === null || _a === void 0 ? void 0 : _a.retryMessages) === null || _b === void 0 ? void 0 : _b.email) {
                    retryMessage = chatbot.settings.retryMessages.email;
                }
                break;
            }
            case models_1.InputType.PHONE: {
                if ((_d = (_c = chatbot.settings) === null || _c === void 0 ? void 0 : _c.retryMessages) === null || _d === void 0 ? void 0 : _d.phone) {
                    retryMessage = chatbot.settings.retryMessages.phone;
                }
                break;
            }
            case models_1.InputType.WEBSITE: {
                if ((_f = (_e = chatbot.settings) === null || _e === void 0 ? void 0 : _e.retryMessages) === null || _f === void 0 ? void 0 : _f.website) {
                    retryMessage = chatbot.settings.retryMessages.website;
                }
                break;
            }
            case models_1.InputType.PAYMENT: {
                retryMessage = t("Payment didnt succeed");
                break;
            }
        }
        retryStep.questionMessages = [{ id: "retry", value: retryMessage }];
        addStep(retryStep);
        setStepsDisplayed([...stepsDisplayed, retryStep]);
    };
    const handleBlockReply = (answer, freshQuestionVariables) => __awaiter(void 0, void 0, void 0, function* () {
        if (answer.questionId === "i-know-you") {
            const secondVisitOptions = stepsDisplayed[0]
                .questionOptions;
            const hasDeclarativeIds = [
                "start-again-item-id",
                "continue-item-id",
            ].includes(secondVisitOptions.items[0].id);
            const chosenOption = secondVisitOptions.items.find((i) => answer.value === i.value);
            return hasDeclarativeIds
                ? (chosenOption === null || chosenOption === void 0 ? void 0 : chosenOption.id) === "start-again-item-id"
                    ? startAgain()
                    : continueWithPreviousAnswers()
                : answer.value === secondVisitOptions.items[0].value
                    ? startAgain()
                    : continueWithPreviousAnswers();
        }
        if (answer.isRetry) {
            displayRetryQuestion();
            return;
        }
        //Backward compatibility with replyBubbles
        if (chatbotAnswers.length > 0 &&
            answer.questionId === chatbotAnswers[chatbotAnswers.length - 1].questionId) {
            displayNextBlock({
                upToDateAnswers: [...chatbotAnswers.slice(0, -1), answer],
                stepsDisplayed,
                freshQuestionVariables,
            });
        }
        else {
            displayNextBlock({
                upToDateAnswers: [...chatbotAnswers, answer],
                stepsDisplayed,
                freshQuestionVariables,
            });
        }
    });
    const startAgain = () => {
        displayNextBlock({ upToDateAnswers: [], stepsDisplayed, skip: true });
        setAnswersInStore([]);
    };
    const continueWithPreviousAnswers = () => {
        var _a;
        setIsContinuingWithPreviousAnswers(true);
        const newStepsDisplayed = [
            ...chatbotAnswers.map((answer) => {
                const { stepIndex } = answer;
                const step = chatbot.steps[stepIndex];
                return {
                    answerType: answer.questionType,
                    id: answer.questionId,
                    chatbotStepIndex: stepIndex,
                    questionMessages: [...step.questionMessages],
                    questionOptions: Object.assign({}, step.questionOptions),
                    logicJumps: Object.assign({}, step.logicJumps),
                    replyLogics: step.replyLogics,
                    replyMessages: step.replyMessages,
                    showReplyAvatar: true,
                };
            }),
        ];
        if ((_a = [...chatbotAnswers].pop()) === null || _a === void 0 ? void 0 : _a.isRedirected) {
            removeLastAnswer();
            chatbotAnswers.splice(-1);
            newStepsDisplayed.splice(-1);
        }
        setStepsInStore(newStepsDisplayed);
        setStepsDisplayed(newStepsDisplayed);
        setTimeout(() => {
            setIsContinuingWithPreviousAnswers(false);
            displayNextBlock({
                upToDateAnswers: [...chatbotAnswers],
                stepsDisplayed: [...newStepsDisplayed],
                skip: true,
            });
        }, 200);
    };
    const handleScrollBottom = () => {
        if (!bottomAnchor.current)
            return;
        scroll.scrollToBottom({
            duration: 500,
            containerId: "scrollable-container",
        });
    };
    const handleSkipToNextQuestion = () => {
        displayNextBlock({
            upToDateAnswers: [...chatbotAnswers],
            stepsDisplayed,
            skip: true,
        });
    };
    return (react_1.default.createElement("div", { className: "overflow-y-scroll w-full lg:w-3/4 min-h-full rounded lg:px-5 px-3 pt-10 relative scrollable-container typebot-chat-view", style: {
            backgroundColor: (0, theme_1.parseTheme)(chatbot).colors.chatbotBackground.value,
        }, id: "scrollable-container" },
        stepsDisplayed.map((step, idx) => (react_1.default.createElement(ChatBlock_1.ChatBlock, { key: step.id + idx, step: step, onReply: handleBlockReply, rollbackToInput: idx === stepsDisplayed.length - 1 && previousTriggered, onNewBubble: handleScrollBottom, onSkipToNextBlock: handleSkipToNextQuestion, keepLastAvatar: (step.answerType !== models_1.InputType.NO_INPUT ||
                stepsDisplayed.length - 1 === idx) &&
                !isExecutingHttpRequest, continueWithPreviousAnswers: isContinuingWithPreviousAnswers, isSpeedTesting: isPreview && disableAnimations }))),
        isExecutingHttpRequest && react_1.default.createElement(LoadingBlock_1.LoadingBlock, null),
        react_1.default.createElement("div", { className: "w-full", ref: bottomAnchor, style: {
                transition: isEnded ? "height 1s" : "",
                height: isEnded ? "5%" : "20%",
            } })));
};
exports.ChatbotView = ChatbotView;
const flushHttpLocalStorage = () => {
    (0, utils_1.removeItemFromLocalStorage)("recentHttpRequestUrl");
    (0, utils_1.removeItemFromLocalStorage)("blockRequest");
    (0, utils_1.removeItemFromLocalStorage)("totalRetryHttp");
};
//# sourceMappingURL=ChatbotView.js.map